import axios from 'axios'
import { API_KEY, API_URL } from '../keys'
import CouponsEntity from '@/entities/api/coupons/coupons'

export const createCoupon = async (
	token: string,
	data: Partial<CouponsEntity>
) => {
	const response = await axios.post(`${API_URL}/coupons`, data, {
		headers: {
			Authorization: `Bearer ${token}`,
			'sce-api-users-key-validation': API_KEY,
			'Content-Type': 'application/json',
		},
		validateStatus: (status) => status < 500,
	})
	if (response) return response
}

export const updateCouponById = async (
	token: string,
	id: string,
	data: Partial<CouponsEntity>
) => {
	const response = await axios.patch(`${API_URL}/coupons/${id}`, data, {
		headers: {
			Authorization: `Bearer ${token}`,
			'sce-api-users-key-validation': API_KEY,
			'Content-Type': 'application/json',
		},
		validateStatus: (status) => status < 500,
	})
	if (response) return response
}

export const fetchCoupons = async (token: string) => {
	const response = await axios.get(`${API_URL}/coupons`, {
		headers: {
			Authorization: `Bearer ${token}`,
			'sce-api-users-key-validation': API_KEY,
			'Content-Type': 'application/json',
		},
		validateStatus: (status) => status < 500,
	})
	if (response) return response
}

export const removeCouponById = async (token: string, id: string) => {
	const response = await axios.delete(`${API_URL}/coupons/${id}`, {
		headers: {
			Authorization: `Bearer ${token}`,
			'sce-api-users-key-validation': API_KEY,
			'Content-Type': 'application/json',
		},
		validateStatus: (status) => status < 500,
	})
	if (response) return response
}
